import React from "react";
import { connect } from "react-redux";

import { getAvailableProducts } from "state/app/selectors";
import { isProductAvailable } from "lib/validate";

import TeachersSchoolList from "components/app/info/TeachersSchoolList";
import SchoolMoneySchoolList from "components/app/info/SchoolMoneySchoolList";

import teachersLogo from "components/assets/images/teachers/teachers-logo--text-right.svg";
import schoolMoneyLogo from "components/assets/images/school_money/school_money-logo--text-right.svg";
import "./AvailableProductsSchoolList.css";

const products = {
  teachers: {
    name: "Teachers2Parents",
    logo: teachersLogo
  },
  school_money: {
    name: "SchoolMoney",
    logo: schoolMoneyLogo
  }
}

class AvailableProductsSchoolList extends React.Component {

  renderProductSchoolList(product) {
    switch (product) {
      case "teachers": return <TeachersSchoolList />;
      case "school_money": return <SchoolMoneySchoolList />;
      default: return null;
    }
  }

  render() {
    return (
      <div className="school-list">
        <h2 className="school-list__heading">Registered Schools</h2>
        {
          this.props.availableProducts.sort().map(product => (
            isProductAvailable(product) ?
              <div className={`school-list__product-section school-list__product-section--${product}`} key={product}>
                <div className="school-list__product-heading">
                  <img className="school-list__product-logo" src={products[product].logo} alt={products[product].name} />
                </div>
                { this.renderProductSchoolList(product) }
              </div>
            : null
          ))
        }
      </div>
    )
  }

}

export default connect(
  state => ({
    availableProducts: getAvailableProducts(state)
  })
)(AvailableProductsSchoolList)



// WEBPACK FOOTER //
// ./src/components/app/info/AvailableProductsSchoolList.js